import React from 'react'
import graph from '../helpers/graph'
// import records from '../testing/records/records'
import { Link } from 'react-router-dom'
import printCharts from '../helpers/printCharts'
import { DonutCharts } from '@stem-sims/great-leaps-react-common'
import customRequest from '../helpers/customRequest'
import getURLParams from '../helpers/getURLParams'
import ChartHelp from '../components/help/ChartHelp'
import redirect from '../components/redirect/redirect'
import message from '../components/message/message'
import moment from 'moment'
import BeatLoader from 'react-spinners/BeatLoader'
import buildQuery from '../helpers/buildQuery'

// import './records.css'

const HIGH_PROBE = "high"
const MIDDLE_PROBE = "middle"
const ELEMENTARY_PROBE = "elementary"

class Records extends React.Component
{
    /*********************
    * Global Variables
    *********************/
    state =
    {
        studentsName : "",
        customerUsername : null,
        adjacent: {
            next: null,
            prev: null
        }, //adjacent students
        rawRecords : [],
        suggestedStory : "high",
        loading: true,
        buttonsDisabled: true,
        donutsLoading: true,
        donutsRefresh: true,
        order: "asc"
    }

    updateRecords = () => {
        return new Promise((resolve, reject) => {
            this.setState({loading: true, donutsRefresh: true}, () => {

                var params = getURLParams()
                customRequest.get('/api/records', {
                    params: {
                    studentName: params.student,
                    customerUsername: params.customer,
                    type: this.props.type
                }})
                .then(({data}) =>
                {
                    if (data.valid == false) {
                        return redirect.send('/students', () => {
                            message.error(data.message ?? "There has been an error getting your student's records.")
                        })
                    }

                    if (this.state.order == "desc") {
                
                        data.rawRecords = data.rawRecords.reverse()
                    }
                    this.setState({...data, customerUsername: params.customer, studentsName: params.student, loading: false, donutsRefresh: false}, () => {
                        graph.initializeChart(data.chartResponses, data.chartGoals, data.startDate, data.endDate)
                        printCharts.printInitialize()
                        resolve()
                        this.setState({buttonsDisabled: false})
                    })
                })
                .catch((err) => {
                    reject(err)
                })
            })
        })
    }

    navButtonClicked = () => {
        this.updateRecords()
        this.setState({buttonsDisabled: true})
    }

    nextPrevClicked = () => {
        this.setState({donutsLoading: true})
        this.navButtonClicked()
    }

    /****************
    * React Functions
    *****************/
    componentDidMount()
    {
        this.updateRecords()
    }

    componentWillUnmount() {
        graph.removeSizeListener()
    }
        
    render()
    {
        var {studentsName, customerUsername, customerUsername, rawRecords, suggestedStory, loading, donutsLoading, donutsRefresh, adjacent, buttonsDisabled} = this.state
        var {type} = this.props
        var storyType = type == HIGH_PROBE || type == MIDDLE_PROBE || type == ELEMENTARY_PROBE
        let query = { student: studentsName }
        if (customerUsername) query['customer'] = customerUsername
        const typicalQuery = buildQuery(query)
        var previousStudent = adjacent.prev
        var nextStudent = adjacent.next

        var params = getURLParams()

        return (
        <React.Fragment>
            <link rel="stylesheet" type="text/css" href="/styles/records.css" />

            <div id = "student-name" class = "row">
                <h1 class = "break-words col-12">View {`${studentsName}${customerUsername ? ` (from ${customerUsername})` : ""}`}'s Records
                
                <ChartHelp />
                </h1>
            </div>

            <div id = "dont-print">

                <div class = "row subheader-text">
                    {previousStudent ? 
                    <div class = "col-6 col-sm-3 col-md-2 no-print-url">
                        <Link to =
                        {{
                            pathname: `/students/records/${storyType ? "stories/" : ""}${type}`,
                            search: `?${buildQuery({customer: previousStudent.customer, student: previousStudent.student})}`,
                            state: { order: this.state.order }
                        }} class = "btn btn-secondary btn-md" style = {{
                            'overflow': 'hidden',
                            'textOverflow': 'ellipsis',
                            'pointerEvents': buttonsDisabled ? 'none': 'all'
                        }}
                        onClick={this.nextPrevClicked}
                        disabled={buttonsDisabled}>
                            Previous Student
                        </Link>
                    </div> : ""}

                    {nextStudent ? 
                    <div class = "col-6 col-sm-3 col-md-2 no-print-url ml-auto">
                        
                        <Link to =
                        {{
                            pathname: `/students/records/${storyType ? "stories/" : ""}${type}`,
                            search: `?${buildQuery({customer: nextStudent.customer, student: nextStudent.student})}`,
                            state: { order: this.state.order }
                        }}
                        class = "btn btn-secondary btn-md"
                        style = {{
                            'overflow': 'hidden',
                            'textOverflow': 'ellipsis',
                            'pointerEvents': buttonsDisabled ? 'none': 'all'
                        }}
                        onClick={this.nextPrevClicked}
                        disabled={buttonsDisabled}>
                                Next Student
                            </Link>
                    </div> : ""}
                </div>

                {donutsLoading ? <div style={{ margin: "0 auto", display: "table", height: "14.5vh"}}>
                <div style={{ display: "table-cell", verticalAlign: "middle", textAlign: "center"}}>
                    <BeatLoader
                        size={15}
                        color={"#123abc"}
                        loading={true}
                        />
                </div>
            </div> : ""}
                
                <div style={{display: donutsLoading ? 'none' : 'inline'}}>
                    <DonutCharts refresh={donutsRefresh} customer={params.customer} student={params.student} onLoaded = {() => {
                        this.setState({donutsLoading: false})
                    }}/>
                </div>

                <div id = "probe-nav" class = "row subheader-text">

                    <div class = "col-12 col-sm-6 col-md-4">
                        <Link to = {`/students/records/phonics?${typicalQuery}`}
                              class = {`nav-btn btn btn-secondary btn-lg ${type == "phonics" ? "active" : ""} no-print-url`}
                              style = {{
                                'pointerEvents': buttonsDisabled ? 'none': 'all'
                              }}
                              disabled = {buttonsDisabled}
                              onClick={this.navButtonClicked}>Phonics</Link>
                    </div>

                    <div class = "col-12 col-sm-6 col-md-4">
                        <Link to = {`/students/records/phrases?${typicalQuery}`}
                              class = {`nav-btn btn btn-secondary btn-lg ${type == "phrases" ? "active" : ""} no-print-url`}
                              style = {{
                                'pointerEvents': buttonsDisabled ? 'none': 'all'
                              }}
                              disabled = {buttonsDisabled}
                              onClick={this.navButtonClicked}>Phrases</Link>
                    </div>

                    <div class = "col-12 col-sm-6 offset-sm-3 col-md-4 offset-md-0">
                        <Link to = {`/students/records/stories/${suggestedStory}?${typicalQuery}`} class = {`nav-btn btn btn-secondary btn-lg ${storyType ? "active" : ""} no-print-url`}
                        style = {{
                            'pointerEvents': buttonsDisabled ? 'none': 'all'
                          }}
                        disabled = {buttonsDisabled}
                        onClick={this.navButtonClicked}>Stories</Link>
                    </div>
                </div>

                {storyType ?
                <div id = "story-nav"  class = "row anti-subheader-text">
                    <div class = "col-sm-10 offset-sm-1">
                        <div class = "row subheader-text">
                            <div class = "col-sm-4">
                                <Link to = {`/students/records/stories/elementary?${typicalQuery}`}
                                      class = {`nav-btn btn btn-secondary alternate-fill btn-lg ${type == ELEMENTARY_PROBE ? "active" : ""} no-print-url`}
                                      style = {{
                                        'pointerEvents': buttonsDisabled ? 'none': 'all'
                                      }}
                                    disabled = {buttonsDisabled}
                                      onClick={this.navButtonClicked}>Elementary</Link>
                            </div>
                            
                            <div class = "col-sm-4">
                                <Link to = {`/students/records/stories/middle?${typicalQuery}`}
                                      class = {`nav-btn btn btn-secondary alternate-fill btn-lg ${type == MIDDLE_PROBE ? "active" : ""} no-print-url`}
                                      style = {{
                                        'pointerEvents': buttonsDisabled ? 'none': 'all'
                                      }}
                                    disabled = {buttonsDisabled}
                                      onClick={this.navButtonClicked}>Middle</Link>
                            </div>
                            
                            <div class = "col-sm-4">
                                <Link to = {`/students/records/stories/high?${typicalQuery}`}
                                      class = {`nav-btn btn btn-secondary alternate-fill btn-lg ${type == HIGH_PROBE ? "active" : ""} no-print-url`}
                                      style = {{
                                        'pointerEvents': buttonsDisabled ? 'none': 'all'
                                      }}
                                    disabled = {buttonsDisabled}
                                      onClick={this.navButtonClicked}>High</Link>
                            </div>
                        </div>
                    </div>
            </div> : ""}

            {loading ? 
                <div style={{ margin: "0 auto", display: "table", height: "50vh"}}>
                    <div style={{ display: "table-cell", verticalAlign: "middle", textAlign: "center"}}>
                        <BeatLoader
                            size={15}
                            color={"#123abc"}
                            loading={true}
                            />
                    </div>
                </div>
                :
                <React.Fragment>
                <div id = "printer-button" class = "pointer float-right"><span class="glyphicon glyphicon-print"></span></div>
                <h3>Student Progress Chart</h3>

                <div id = "progress-chart" class = "overflow-hidden">

                </div>
                </React.Fragment>
            }
            </div>

            <div id = "printable-charts">
                <h2>
                {
                    storyType ?
                    type == HIGH_PROBE ? "High School" : "" +
                    type == MIDDLE_PROBE ? "Middle School" : "" +
                    type == ELEMENTARY_PROBE ? "Elementary School" : "" +
                    " Stories"
                    :

                    type == "phrases" ? "Phrases" : "" +
                    type == "phonics" ? "Phonics" : ""
                }
                </h2>
            </div>


            <hr />

            <div class = "row">
                <div class = "col-4 offset-4 col-sm-4 offset-sm-4 col-md-4 offset-md-4 col-lg-4 offset-lg-4">
                    <h3 class = "subheader-text no-top-margin">Raw Exercise Records</h3>
                </div>
                {
                    rawRecords.length > 1 ?
                    <div class="col-2 offset-2 col-sm-2 offset-sm-2 col-md-1 offset-md-3 col-lg-1 offset-lg-3">
                        <select id="records-order" class="form-control" defaultValue={this.state.order} onChange={(event) => {
                            
                            this.setState({ order: event.target.value, rawRecords: this.state.rawRecords.reverse() })
                        }}>
                            <option value="asc" selected="">ASC</option>
                            <option value="desc">DESC</option>
                        </select>
                    </div>
                    
                    : ""
                }
                
            </div>

            <div id = "raw-records" class = "row table-responsive text-center">
                <table class = "table">
                    <thead>
                        <tr>
                            <th>Date/Time</th>
                            <th>Exercise Number</th>
                            <th>Responses</th>
                            <th>Time (seconds)</th>
                            <th>Words/Min</th>
                            <th>Errors</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rawRecords.length == 0 ?
                        <tr>
                            <td colspan = "6" class = "text-center">No data yet. <Link to = {`/dashboard`}>Start an exercise with this student</Link> to record exercise data.</td>
                        </tr> : "" }

                        {rawRecords.map((rawRecord) =>
                        {
                            return (<tr key={rawRecord.date} class = {rawRecord.responseGoal && rawRecord.errorGoal ? "goal-row" : ""}>
                                        <td>
                                            {
                                                moment(rawRecord.date)
                                                .local()
                                                .format('MMM D, YYYY hh:mm A')
                                            }</td>
                                        <td>{rawRecord.number}</td>
                                        <td class = {rawRecord.responseGoal ? "goal-cell" : ""}>{rawRecord.responses} / {rawRecord.maxResponses}</td>
                                        <td>{rawRecord.time}</td>
                                        <td>{rawRecord.wpm}</td>
                                        <td class = {rawRecord.errorGoal ? "goal-cell" : ""}>{rawRecord.errors}</td>
                                    </tr>)
                        })}
                    </tbody>
                </table>
            </div>
        </React.Fragment>
        )
    }
}

export default Records
